import habitEarth from './sets/habit-earth-intro.js';
import { toBlob } from 'html-to-image';
import JSZip from 'jszip';

const sets = [habitEarth];
const params = new URLSearchParams(location.search);
let active = sets.find(set => set.slug === params.get('set')) || sets[0];
let selected = 0;

function safe(value = '') { return String(value).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
function lines(value = '') { return safe(value).replaceAll('\n', '<br>'); }
function imageStyle(path) { return path ? `style="--image:url('${safe(path)}')"` : ''; }
function brandMark(brand, inverse = false) {
  return `<div class="brand ${inverse ? 'brand--inverse' : ''}"><span class="brand-orbit">◯</span><span>${safe(brand.name)}</span></div>`;
}

function slideMarkup(slide, index, brand) {
  const common = `data-index="${index}" class="slide slide--${slide.type}" ${imageStyle(slide.image)}`;
  const footer = `<footer>${brandMark(brand)}<span>${safe(brand.handle)}</span><span>${String(index + 1).padStart(2, '0')} / ${String(active.slides.length).padStart(2, '0')}</span></footer>`;
  if (slide.type === 'cover') return `<article ${common}>
    <div class="photo"></div><div class="grain"></div><div class="cover-shade"></div>
    <div class="cover-top">${brandMark(brand, true)}<span>SWIPE TO EXPLORE ↗</span></div>
    <div class="cover-copy"><p class="eyebrow">${safe(slide.eyebrow)}</p><h1>${lines(slide.title)}</h1><p class="lede">${safe(slide.body)}</p></div>
  </article>`;
  if (slide.type === 'statement') return `<article ${common}>
    <div class="topline"><span>${safe(slide.number)}</span><span>${safe(slide.eyebrow)}</span></div>
    <div class="statement-art"><span class="sun"></span><span class="arch arch-a"></span><span class="arch arch-b"></span><span class="ground"></span></div>
    <div class="main-copy"><h2>${lines(slide.title)}</h2><p>${safe(slide.body)}</p></div>${footer}
  </article>`;
  if (slide.type === 'image') return `<article ${common}>
    <div class="image-panel"><div class="photo"></div><div class="image-label">INTERACTIVE MODEL / STUDIO</div></div>
    <div class="image-copy"><div class="topline"><span>${safe(slide.number)}</span><span>${safe(slide.eyebrow)}</span></div><h2>${lines(slide.title)}</h2><p>${safe(slide.body)}</p></div>${footer}
  </article>`;
  if (slide.type === 'metrics') return `<article ${common}>
    <div class="metrics-bg"><div class="photo"></div></div><div class="metrics-shade"></div>
    <div class="topline inverse"><span>${safe(slide.number)}</span><span>${safe(slide.eyebrow)}</span></div>
    <h2>${lines(slide.title)}</h2><div class="metric-list">${slide.metrics.map(([v, l]) => `<div><strong>${safe(v)}</strong><span>${safe(l)}</span></div>`).join('')}</div>
    <footer class="inverse">${brandMark(brand, true)}<span>${safe(brand.handle)}</span><span>${String(index + 1).padStart(2, '0')} / ${String(active.slides.length).padStart(2, '0')}</span></footer>
  </article>`;
  if (slide.type === 'steps') return `<article ${common}>
    <div class="topline"><span>${safe(slide.number)}</span><span>${safe(slide.eyebrow)}</span></div><h2>${lines(slide.title)}</h2>
    <div class="step-list">${slide.steps.map(([n, t]) => `<div class="step"><span>${n}</span><p>${safe(t)}</p></div>`).join('')}</div>
    <div class="air-lines"><i></i><i></i><i></i></div>${footer}
  </article>`;
  if (slide.type === 'principles') return `<article ${common}>
    <div class="topline"><span>${safe(slide.number)}</span><span>${safe(slide.eyebrow)}</span></div><h2>${lines(slide.title)}</h2>
    <div class="principle-grid">${slide.items.map((item, i) => `<div><span>${String(i + 1).padStart(2, '0')}</span><b>${safe(item)}</b></div>`).join('')}</div>${footer}
  </article>`;
  if (slide.type === 'quote') return `<article ${common}>
    <div class="quote-image"><div class="photo"></div></div><div class="quote-copy"><div class="topline"><span>${safe(slide.number)}</span><span>${safe(slide.eyebrow)}</span></div><h2>${lines(slide.title)}</h2><p>${safe(slide.body)}</p></div>${footer}
  </article>`;
  return `<article ${common}>
    <div class="cta-orbit"><i></i><i></i><i></i></div>${brandMark(brand, true)}<div class="cta-copy"><p class="eyebrow">${safe(slide.eyebrow)}</p><h2>${lines(slide.title)}</h2><p>${safe(slide.body)}</p><span class="button">${safe(slide.button)} ↗</span></div><div class="cta-url">${safe(brand.handle)} · ${safe(brand.url)}</div>
  </article>`;
}

function applyBrand(brand) {
  const c = brand.colors;
  document.documentElement.style.cssText = `--sand:${c.sand};--charcoal:${c.charcoal};--terra:${c.terracotta};--olive:${c.olive};--clay:${c.clay}`;
}

function render() {
  applyBrand(active.brand);
  if (params.has('render')) {
    document.body.className = 'render-mode';
    app.innerHTML = `<main class="render-stack">${active.slides.map((s, i) => slideMarkup(s, i, active.brand)).join('')}</main>`;
    return;
  }
  app.innerHTML = `<div class="studio">
    <aside><div class="tool-brand"><span class="tool-icon">C</span><div><b>Carousel Studio</b><small>Brand publishing tool</small></div></div>
      <label>CONTENT SET</label><select id="set-select">${sets.map(s => `<option value="${s.slug}">${safe(s.name)}</option>`).join('')}</select>
      <div class="aside-heading"><label>SLIDES</label><span>${active.slides.length}</span></div>
      <nav class="slide-nav">${active.slides.map((s, i) => `<button class="${i === selected ? 'active' : ''}" data-slide="${i}"><span>${String(i + 1).padStart(2, '0')}</span><div><b>${safe(s.eyebrow)}</b><small>${safe(s.title.replaceAll('\n', ' '))}</small></div></button>`).join('')}</nav>
      <div class="brand-panel"><label>BRAND KIT</label>${Object.entries(active.brand.colors).map(([k, v]) => `<div class="color-row"><span class="swatch" style="background:${v}"></span><span>${safe(k)}</span><code>${safe(v)}</code></div>`).join('')}</div>
    </aside>
    <section class="workspace"><header><div><small>EDITING SET</small><h1>${safe(active.name)}</h1></div><div class="actions"><button id="copy-command">Copy export command</button><button class="primary" id="download">Export PNG set</button></div></header>
      <div class="canvas"><button class="arrow" id="prev">←</button><div class="preview">${slideMarkup(active.slides[selected], selected, active.brand)}</div><button class="arrow" id="next">→</button><div class="export-progress" id="export-progress" aria-live="polite"></div></div>
      <div class="status"><span>Instagram portrait</span><b>1080 × 1350</b><span>PNG · sRGB</span></div>
    </section></div>`;
  bind();
}

function bind() {
  document.querySelectorAll('[data-slide]').forEach(btn => btn.onclick = () => { selected = Number(btn.dataset.slide); render(); });
  document.querySelector('#prev').onclick = () => { selected = (selected - 1 + active.slides.length) % active.slides.length; render(); };
  document.querySelector('#next').onclick = () => { selected = (selected + 1) % active.slides.length; render(); };
  document.querySelector('#set-select').onchange = e => { active = sets.find(s => s.slug === e.target.value); selected = 0; render(); };
  document.querySelector('#copy-command').onclick = async e => { await navigator.clipboard.writeText(`npm run export -- ${active.slug}`); e.target.textContent = 'Copied'; };
  document.querySelector('#download').onclick = exportSet;
}

async function exportSet() {
  const button = document.querySelector('#download');
  const progress = document.querySelector('#export-progress');
  button.disabled = true;
  button.textContent = 'Rendering…';
  const stage = document.createElement('div');
  stage.className = 'export-stage';
  stage.innerHTML = active.slides.map((slide, i) => slideMarkup(slide, i, active.brand)).join('');
  document.body.append(stage);
  const zip = new JSZip();
  try {
    await document.fonts.ready;
    const nodes = [...stage.querySelectorAll('.slide')];
    for (let i = 0; i < nodes.length; i++) {
      progress.textContent = `Rendering slide ${i + 1} of ${nodes.length}…`;
      const blob = await toBlob(nodes[i], { width: 1080, height: 1350, pixelRatio: 1, cacheBust: true });
      if (!blob) throw new Error(`Slide ${i + 1} did not render`);
      zip.file(`${String(i + 1).padStart(2, '0')}.png`, blob);
    }
    zip.file('manifest.json', JSON.stringify({ set: active.slug, brand: active.brand.name, size: '1080x1350', slides: nodes.length }, null, 2));
    progress.textContent = 'Building ZIP…';
    const archive = await zip.generateAsync({ type: 'blob' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(archive);
    link.download = `${active.slug}-instagram.zip`;
    link.click();
    setTimeout(() => URL.revokeObjectURL(link.href), 30000);
    progress.textContent = `Downloaded ${nodes.length} Instagram images`;
  } catch (error) {
    console.error(error);
    progress.textContent = `Export failed: ${error.message}`;
  } finally {
    stage.remove();
    button.disabled = false;
    button.textContent = 'Export PNG set';
  }
}

render();
